module.exports = __webpack_public_path__ + "img/category_cover_Science.4b39dc0.webp";